module.exports = __webpack_public_path__ + "img/logo-SB.151cfcc1.png";